import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

type HeaderWithInfoProps = {
  title: React.ReactNode; // <-- antes probablemente era string
  help?: React.ReactNode;
  tooltipPlacement?:
    | "top"
    | "topLeft"
    | "topRight"
    | "bottom"
    | "bottomLeft"
    | "bottomRight";
};

export const HeaderWithInfo: React.FC<HeaderWithInfoProps> = ({
  title,
  help,
  tooltipPlacement,
}) => {
  // Ejemplo de estructura interna:
  // muestra el "title" tal cual (que ahora puede ser <CompactTitle/>)
  // y un ícono con tooltip para "help".
  return (
    <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
      {title}
      {help ? (
        <Tooltip title={help} placement={tooltipPlacement ?? "top"}>
          <InfoCircleOutlined />
        </Tooltip>
      ) : null}
    </span>
  );
};
